import { useState } from 'react';
import '../Styles/CategoryStyles.css';
import { theme } from '../../theme/theme';
import { ThemeProvider } from '@mui/material/styles';
import ItemCategoryList from '../Statefull/ItemCategoryList';
import ItemCategoryModal from './Modals/ItemCategoryModal';
import { Typography } from '@mui/material';

const ManageItemCategory = () => {
  const [mode, setMode] = useState<'add' | 'edit'>('add');
  const [modal, setModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<any>(null);

  

  const handleEditCategory = (category: any) => {
    console.log('Editing category:', category);
    setSelectedCategory(category);
    setMode('edit');
    setModal(true);
  };

  const handleAddCategory = () => {
    setSelectedCategory(null);
    setMode('add');
    setModal(true);
  };

  // const handleCloseModal = () => {
  //   setModal(false);
  //   setSelectedCategory(null);
  // };

  return (
    <ThemeProvider theme={theme}>
      <>
        <Typography variant="h5" fontWeight="bold" mb={2}>
          Manage Item Category
        </Typography>
        <ItemCategoryList
          editCategory={handleEditCategory}
          mode={mode}
          modal={modal}
          setModal={setModal}
          setMode={setMode}
          addCategory={handleAddCategory}
        />
        
        <ItemCategoryModal
          open={modal}
          setOpen={setModal}
          mode={mode}
          initialData={selectedCategory ? {
            id: selectedCategory.id,
            englishName: selectedCategory.nameEnglish,
            arabicName: selectedCategory.nameArabic,
            addedBy: selectedCategory.addedBy,
            storeId: selectedCategory.storeId,
            storeType: selectedCategory.storeType,
          } : undefined}
        />
      </>
    </ThemeProvider>
  );
};

export default ManageItemCategory;
